import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import CreateIcon from '@mui/icons-material/Create';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import { administration_types } from '../../../helper/constants.helper';

const AssessmentItem = ({ assessment }) => {
  return (
    <div className="assessment-wrapper  margin-top--md">
      <div className="image-container">
        <img alt={assessment.shortTitle} src={assessment.logo} />
      </div>
      <div className="details-container">
        <h3 style={{ marginTop: '-10px' }}>
          <span
            style={{
              borderBottom: '1px solid lightgrey',
              paddingBottom: '10px',
              color: 'black'
            }}>
            {assessment.name}
          </span>
        </h3>
        <div className="flex-container margin-top--lg">
          <DescriptionIcon fontSize="small" color="primary" />
          <p style={{ margin: '-2px 0px 0px 5px' }}>{assessment.shortTitle}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <RecommendOutlinedIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>{assessment.eligibility}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <HourglassEmptyIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>{assessment.duration}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <CreateIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>
            {assessment.administrations
              ?.map((administration) => administration_types[administration])
              .filter(Boolean)
              .join(', ')}
          </p>
        </div>
      </div>
      <style jsx>
        {`
          .assessment-wrapper {
            display: flex;
            justify-content: center;
            width: 100%;
            border: 1px solid lightgrey;
            border-radius: 10px;
            overflow: hidden;
          }
          .image-container {
            width: 40%;
            overflow: hidden;
          }
          .image-container img {
            object-fit: cover;
            height: 100%;
          }
          .details-container {
            width: 60%;
            padding: 25px 20px;
            min-height: 100px;
            box-sizing: border-box;
          }
          @media only screen and (max-width: 600px) {
            .assessment-wrapper {
              flex-direction: column;
            }
            .image-container {
              width: 100%;
            }
            .details-container {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AssessmentItem;
